import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, OccConfig, PageMetaResolver, UrlModule } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { UigContentSearchComponent } from './component/uig-content-search.component';
import { UigContentSearchMetaResolver } from './uig-content-search-meta.resolver';
import { UigContentSearchAdapter } from './uig-content-search.adapter';



@NgModule({
  declarations: [
    UigContentSearchComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    UrlModule,
    RouterModule,
    NgSelectModule,
    SpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ContentSearchComponent: {
          path: 'contentsearch/:query',
          component: UigContentSearchComponent
        },
      }
    } as CmsConfig),
    ConfigModule.withConfig({
      routing: {
        routes: {
          contentSearch: {
            paths: ['/contentsearch/:query']
          },
        },
      },
      backend: {
        occ: {
          endpoints: {
            contentSearch: '/contentsearch',
          },
        },
      },
    } as OccConfig),
  ],
  providers: [
    {
      provide: UigContentSearchAdapter,
      useClass: UigContentSearchAdapter,
    }
  ]
})
export class UigContentSearchModule {
  static forRoot(): ModuleWithProviders<UigContentSearchModule> {
    return {
      ngModule: UigContentSearchModule,
      providers: [{
        provide: PageMetaResolver,
        useExisting: UigContentSearchMetaResolver,
        multi: true,
      }],
    };
  }
}
